import { URLS } from 'config';

export const ID = () =>
  (
    Date.now().toString(36) +
    Math.random()
      .toString(36)
      .substr(2, 5)
  ).toUpperCase();

export const getStorage = (name = 'carsapp') => localStorage.getItem(name) ?
  JSON.parse(localStorage.getItem(name)) : {};

export const setStorage = (obj = {}, name = 'carsapp') => {
  localStorage.setItem(name, JSON.stringify({ ...getStorage(name), ...obj }));
};

export const numberMask = (number) => {
  const nm = number.slice(2).match(/(\d{3})(\d{3})(\d{4})/);
  return `(${nm[1]}) ${nm[2]}-${nm[3]}`;
};


export const generateNextRoute = (user) => {
  // const routesBySteps = [URLS.NAME, URLS.BIRTHDAY,
  //   URLS.GENDER, URLS.WORKING, URLS.DOWNPAYMENTS,
  //   URLS.MOUNTHLY, URLS.CONFIRMATION, URLS.EXPERIENCE,
  //   URLS.UPLOAD];
  const priorityRoutes = {
    [URLS.NAME]: 1,
    [URLS.BIRTHDAY]: 2,
    [URLS.GENDER]: 3,
    [URLS.WORKING]: 4,
    [URLS.DOWNPAYMENTS]: 5,
    [URLS.MOUNTHLY]: 5,
    [URLS.CONFIRMATION]: 6,
    [URLS.EXPERIENCE]: 7,
    [URLS.UPLOAD]: 8
  };
  const paramByRoute = {
    userName: URLS.NAME,
    name: URLS.NAME,
    birthDay: URLS.BIRTHDAY,
    gender: URLS.GENDER,
    workingStatus: URLS.WORKING,
    downPaymentsAviable: URLS.DOWNPAYMENTS,
    monthlyIncome: URLS.MOUNTHLY,
    statusOfConfirmMonthlyIncome: URLS.CONFIRMATION,
    minDownPaymentAgreeOrNot: URLS.CONFIRMATION,
    workingExperience: URLS.EXPERIENCE
  };

  let currentValueRoute = 0;
  let currentRoute = URLS.NAME;

  if (user.uploadedFiles >= 2) {
    return URLS.APPROVED;
  }

  if (user.registrationDone === true) {
    return URLS.PROFILECARS;
  }

  Object.keys(user).forEach((el) => {
    const getRoute = paramByRoute[el];
    const getValueRoute = priorityRoutes[getRoute];

    if (currentValueRoute < getValueRoute) {
      currentValueRoute = getValueRoute;
      if (getValueRoute >= 8) {
        currentRoute = URLS.APPROVED;
      } else {
        currentRoute = getRoute;
      }
    }
  });

  return currentRoute;
};




// WEBPACK FOOTER //
// ./src/utilz/index.js